import { createAsyncThunk } from '@reduxjs/toolkit';
import { createAsyncThunkWithCaching } from './thunkWrapper';

export const createServiceThunk = (key, serviceCall) =>
    createAsyncThunk(key, async (payload, thunkAPI) => {
        try {
            return await serviceCall(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    });

export const createCachedServiceThunk = (key, serviceCall) =>
    createAsyncThunkWithCaching(key, async (payload, thunkAPI) => {
        try {
            return await serviceCall(payload);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    });

export const createAddThunk = (key, serviceCall) =>
    createAsyncThunk(key, async (values, thunkAPI) => {
        try {
            return await serviceCall(values);
        } catch (error) {
            return thunkAPI.rejectWithValue({
                message: error?.message || error?.error || 'unknown',
                details: error?.details || null,
            });
        }
    });

export const createClearAction = (key, clearActions) =>
    createAsyncThunk(key, (_, { dispatch }) => {
        clearActions.forEach((action) => dispatch(action()));
    });
